const VERDICT_COLOR = {
  Completed: "text-emerald-400", Excellent: "text-emerald-400", "On Track": "text-sky-400",
  "Needs Attention": "text-amber-400", Started: "text-sky-400", "No Progress Yet": "text-slate-400", "No Assignment": "text-slate-500",
};

export const PerformanceTable = ({ perTeam }) => (
  <div className="panel overflow-x-auto">
    <table data-testid="performance-table" className="w-full min-w-[720px] text-sm">
      <thead>
        <tr className="border-b border-[color:var(--border)] text-left">
          {["Team", "Items Done", "Points Done", "Target Points", "% Productivity", "Performance"].map((h) => (
            <th key={h} className="label px-4 py-3 font-normal">{h}</th>
          ))}
        </tr>
      </thead>
      <tbody>
        {perTeam.map((p) => (
          <tr key={p.team.id} data-testid={`performance-row-${p.team.id}`} className="border-b border-[color:var(--border)] last:border-0 hover:bg-white/[0.02]">
            <td className="px-4 py-3 font-display font-semibold">{p.team.name}</td>
            <td className="px-4 py-3 font-mono">{p.doneCount}</td>
            <td data-testid={`performance-points-${p.team.id}`} className="px-4 py-3 font-mono">{p.pointsDone}</td>
            <td className="px-4 py-3 font-mono">{p.target}</td>
            <td data-testid={`performance-productivity-${p.team.id}`} className="px-4 py-3 font-mono text-amber-400">{p.pct.toFixed(1)}%</td>
            <td data-testid={`performance-status-${p.team.id}`} className={`px-4 py-3 font-medium ${VERDICT_COLOR[p.verdict]}`}>{p.verdict}</td>
          </tr>
        ))}
      </tbody>
    </table>
    <p className="border-t border-[color:var(--border)] px-4 py-3 font-mono text-[11px] text-[color:var(--muted)]">
      % Productivity = (Points Done / Target Points) x 100% · Points = sum of weights of completed jobs
    </p>
  </div>
);
